import React, { useEffect, useRef, useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import CommonTable from "../../components/commonTable/commonTable";
import CategoryService from "../../services/category.service";
import { ToastContainer } from "react-toastify";
import useDialogState from "../../hook";

const Categories = () => {
  const dropdownRef = useRef();
  const isInitialMount = useRef(true);
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState("");
  const [searchOutside, setSearchOutside] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState("");


  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const handleChange = (e) => {
    setSearchText(e.target.value);
    setSearchOutside(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setSearchOutside(false);
    }
  };

  const getAllData = async () => {
    // setLoader()
    const response = await CategoryService.GetAllCategory(pageNumber, pageSize, searchText);
    const data = response.data.apiresponse.data;
    setData(data.categories)
    setTotalCount(data.totalRecords);
    // unSetLoader()
  };

  useEffect(() => {
    getAllData();
  }, [pageNumber, pageSize, searchText]);

  return (
    <>
      <div className="w-full px-5 pb-10">
        <div className="py-10">
          <h1 className="text-base font-semibold leading-7 text-white">
            Category List(Images)
          </h1>
        </div>
        <div>
          <div className="relative mb-5">
            <div className="input flex items-center gap-1">
              <div className="flex gap-1 items-center bg-transparent w-full">
                <IoSearchOutline className="bg-transparent text-22" />
                <input
                  type="text"
                  className="input"
                  placeholder="Search....."
                  onChange={handleChange}
                  value={searchText}
                />
              </div>
              <IoClose
                className="bg-transparent text-22 cursor-pointer"
                onClick={() => {
                  setSearchText("");
                  setSearchOutside(false);
                }}
              />
            </div>
          </div>
        </div>
        <CommonTable
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          totalCount={totalCount}
          pageSize={pageSize}
          pageNumber={pageNumber}
          tableData={data}
          getAllData={getAllData}
          load={loader}
        />
        <ToastContainer autoClose={1500} />
      </div>
    </>
  );
};

export default Categories;
